<div
  class="buttons-floating-container"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  [class.width-reduced-sidenav]="isSideNavReduced"
  [class.width-full-sidenav]="!isSideNavReduced"
>
  <div class="left-section" fxLayout="row" fxLayoutAlign="start center"></div>

  <div class="right-section" fxLayout="row" fxLayoutAlign="end center">
    <ng-container *ngFor="let button of buttonsConfiguration">
      <app-button
        [text]="button.text ?? ''"
        [btnType]="button.type ?? 'primary'"
        [color]="button.color ?? 'primary'"
        [icon]="button.icon ?? ''"
        [iconPosition]="button.iconPosition ?? 'left-icon'"
        [iconType]="button.iconType ?? 'mat-icon'"
        [isSpinner]="button.isSpinner ?? false"
        [isSpinning]="(button.isSpinner && isSpinning) ?? false"
        [disabled]="disabled"
        (click)="onClickHandler(button.onClickEventName ?? '')"
      >
      </app-button>
    </ng-container>
  </div>
</div>
